module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_3009.bd814ffd.png";